var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"white","height":"510","flat":""}},[_c('v-container',{staticClass:"mt-4"},[_c('v-row',{staticClass:"pa-5"},[_c('Visualizer2')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }